export let quality = "MD";

export const ArtworksCollection = [
    {
        name: "Un vascello di pietra",
        description: "La parete delle pareti, ovvero la parete nord del Civetta, Dolomiti, Italia. Questa foto è stata scattata dalle pendici del Monte Pore, attorno al passo Giau.",
        position: { x: 0.245, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a destra
        size: 2.37,
        url: "EL_04298.jpg",
        author: "Elia Lazzari",
        year: 2021,
        redirectUrl: "https://www.eliusoutdoor.com/civetta"
    },
    {
        name: "Armoniose montagne",
        description: "Le morbide curvature delle creste dolomitiche ci preparano ad uno degli spettacoli più belli che vedremo",
        position: { x: -2.784, y: 1.729, z: -3.569 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato destro, a sinistra
        size: 2.37,
        url: "DSC08697-HDR-2.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/team-sunset"
    },
    {
        name: "Armoniose montagne 2",
        description: "Poco prima del tramonto dalla cima de Zita, val di Zoldo, Dolomiti, Italia.",
        position: { x: -4.645, y: 1.689, z: -2.09 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a destra
        size: 1.35,
        url: "DSC08695-HDR-2.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/cirri-come-aurore"
    },
    {
        name: "L'uomo aspira alla luce",
        description: "Van de Zita, valle di Zoldo, Dolomiti. In questo scatto ho cercato di rappresentare la lotta dell'uomo per raggiungere la luce, la libertà, la felicità. Un piccolo soggetto umano immerso in una vasta scena di fine inverno, ammira i rossi cirri infuocati del cielo.",
        position: { x: -4.645, y: 1.689, z: 0.71 },
        rotation: { x: -31.415, y: -39.278, z: 50.269 }, // piano terra facciata centrale, a sinistra
        size: 1.35,
        url: "DSC08787.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/cirri-come-aurore"
    },
    {
        name: "Il tramonto più bello",
        description: "Non trovo parole per descrivere questo tramonto. Sono rimasto senza fiato. Questa foto è stata scattata dal van de Zita, Dolomiti, Italia. Questo tramonto è per noi un evento molto speciale, perché è stato il tramonto che ha dato il via al progetto Team Sunset.",
        position: { x: -2.784, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a destra
        size: 2.37,
        url: "DSC08782.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/cirri-come-aurore"
    },
    {
        name: "Alba dal monte Altissimo",
        description: "Dopo un tramonto turbolento e difficile da ammirare, l'alba ci ha regalato uno spettacolo indimenticabile. Questa foto è stata scattata dal monte Altissimo, gruppo del Baldo, Italia.",
        position: { x: 0.245, y: 1.63, z: 2.371 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // piano terra lato sinistro, a sinistra
        size: 2.37,
        url: "DSC00901.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/"
    },
    {
        name: "Ora blu dal Mondeval",
        description: "La quiete dell'ora blu è una delle cose più rilassanti e pacifiche che esistano. Questa foto è stata scattata dal Mondeval, Dolomiti, Italia.",
        position: { x: -2.799, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più lontana
        size: 1.225,
        url: "DSC01662.jpg",
        author: "Elia Lazzari",
        year: 2023,
        redirectUrl: "https://www.eliusoutdoor.com/dolomites-nights"
    },
    {
        name: "Un gigante buono",
        description: "Rosea vista del Monte Pelmo dal rifugio Torrani, Civetta, Dolomiti, Italia.",
        position: { x: -0.120, y: 5.589, z: -0.629 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata destra, più vicina
        size: 1.225,
        url: "DSC07940.jpg",
        author: "Elia Lazzari",
        year: 2020,
        redirectUrl: "https://www.eliusoutdoor.com/team-sunset"
    },
    {
        name: "Tramonto in cima al Civetta",
        description: "Cima del Civetta, Dolomiti. Scatto realizzato durante un infuocato tramonto in cima al Civetta. La luce era così intensa che il cielo sembrava in fiamme.",
        position: { x: -0.12, y: 5.589, z: -0.584 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più vicina
        size: 1.225,
        url: "DSC09633-Pano.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/cirri-come-aurore"
    },
    {
        name: "La luna riposa su un soffice cuscino di nuvole",
        description: "Quiete e pace in una notte di mezza estate, con la luna che riposa su un soffice cuscino di nuvole. Sull'orizzonte si staglia la Marmolada. Noi eravamo sulla cima del Civetta e non potevamo sapere che poche ore dopo si sarebbe staccato un pezzo di montagna, che avrebbe causato una frana di proporzioni epiche.",
        position: { x: -2.799, y: 5.589, z: -0.589 },
        rotation: { x: -31.415, y: -37.699, z: 50.269 }, // soppalco facciata sinistra, più lontana
        size: 1.225,
        url: "DSC09646.jpg",
        author: "Elia Lazzari",
        year: 2022,
        redirectUrl: "https://www.eliusoutdoor.com/cirri-come-aurore"
    },
];
export default ArtworksCollection;